export default __webpack_public_path__ + "static/media/civicus.a7d46946.svg";